export const CUTTING_PACKAGE_SET_ITEM_STATUS =
  'CUTTING_PACKAGE_SET_ITEM_STATUS';
export const CUTTING_PACKAGE_SET_FIELD = 'CUTTING_PACKAGE_SET_FIELD';
export const CUTTING_PACKAGE_SET_ITEM_MACHINING =
  'CUTTING_PACKAGE_SET_ITEM_MACHINING';
